class LoadMore extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /**
     * @type {Section[]}
     * @public
     */
    this.sections = [
      {
        id: 'template-blog',
        section: this.dataset.id,
        selector: '.shopify-section',
      },
    ]

    /**
     * @type {FilterData[]}
     * @public
     */
    this.filterData = []

    /**
     * @type {{ previous: URLSearchParams, current: URLSearchParams, initial: URLSearchParams }}
     * @public
     */
    this.searchParams = {
      // eslint-disable-next-line compat/compat
      previous: new URLSearchParams(window.location.search),
      // eslint-disable-next-line compat/compat
      current: new URLSearchParams(window.location.search),
      // eslint-disable-next-line compat/compat
      initial: new URLSearchParams(window.location.search),
    }
  }

  /**
   * @param {Function} filterDataUrl
   * @param {SubmitEvent} e
   *
   * @returns {void}
   */
  fromCache (filterDataUrl, e) {
    const html = this.filterData.find((element) => filterDataUrl(element)).html

    this.log('fromCache', { filterDataUrl, e, html })

    this.render(html, e)
  }

  /**
   * @param {String} section
   * @param {String} url
   * @param {SubmitEvent} e
   *
   * @returns {void}
   */
  async fromFetch (section, url, e) {
    const html = await window.BAO.sectionRenderer.fetchSingle(section, url)

    this.log('fromFetch', { section, url, html })

    this.filterData.push({ html, url })

    this.render(html, e)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', this.onPaginationClick.bind(this))
  }

  onPaginationClick (e) {
    if (!e.target.closest(this.els?.pagination?.selector)) return

    e.preventDefault()

    const anchor = e.target.closest('a')
    this.log('onPaginationClick', { anchor })
    if (!anchor || anchor.getAttribute('href') === '' || anchor.disabled) {
      return
    }

    const href = anchor.getAttribute('href')
    this.log('onPaginationClick', { href })
    // eslint-disable-next-line compat/compat
    const paginationSearchParams = new URLSearchParams(href.split('?')[1])
    const wantedPage = paginationSearchParams.get('page') ?? '1'
    // eslint-disable-next-line compat/compat
    const currentSearchParams = new URLSearchParams(
      this.searchParams.current.toString(),
    )
    currentSearchParams.set('page', wantedPage)

    this.renderPage({ searchParams: currentSearchParams.toString(), e })
  }

  /**
   * @param {Object}
   * @param {String} searchParams
   * @param {InputEvent} [e]
   * @param {Boolean} [updateURLHash]
   *
   * @returns {void}
   */
  renderPage ({ searchParams, e, updateURLHash = true } = {}) {
    this.log('renderPage', { searchParams, e, updateURLHash })

    this.searchParams.previous = this.searchParams.current
    // eslint-disable-next-line compat/compat
    this.searchParams.current = new URLSearchParams(searchParams)

    this.loading = true

    this.sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${
        section.section
      }&${this.searchParams.current.toString()}`
      /**
       * @param {FilterData} element
       *
       * @returns {Boolean}
       */
      const filterDataUrl = (element) => element.url === url

      this.log('renderPageSections', { section, url })

      this.filterData.some((element) => filterDataUrl(element))
        ? this.fromCache(filterDataUrl, e)
        : this.fromFetch(section.section, url, e)
    })

    if (updateURLHash) this.updateURLHash(this.searchParams.current)
  }

  /**
   * @param {String} html
   * @param {SubmitEvent} e
   *
   * @returns {void}
   */
  render (html, e) {
    this.renderGridContainer(html, e)
    this.renderPagination(html)

    this.loading = false
  }

  /**
   * @param {String} html
   * @param {PointerEvent} e
   *
   * @returns {void}
   */
  renderGridContainer (html, e) {
    const direction = this.getPaginationDirection(e)
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const newItems = document.createDocumentFragment()
    const newElements = window.BAO.Utils.getElements(this.els.item.selector, {
      context: parsedHTML,
    })

    newElements.forEach((el) => newItems.appendChild(el))

    if (direction == null) {
      this.els['item-container'].element.innerHTML = ''
      this.els['item-container'].element.append(newItems)
    } else if (direction === 'PREVIOUS') {
      this.els['item-container'].element.prepend(newItems)
    } else if (direction === 'NEXT') {
      this.els['item-container'].element.append(newItems)
    }

    document
      .querySelectorAll('[data-load-more-el="item"] img[srcset]')
      .forEach((image) => {
        // eslint-disable-next-line no-self-assign
        image.outerHTML = image.outerHTML
      })
  }

  /**
   * @param {string} html
   */
  renderPagination (html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    this.renderLoadPrevious(parsedHTML)
    this.renderLoadMore(parsedHTML)
  }

  /**
   * @param {Document} html
   */
  renderLoadPrevious (html) {
    if (!this.shouldRerenderLoadPrevious) return

    return this._renderEl('load-previous', html)
  }

  /**
   * @param {Document} html
   */
  renderLoadMore (html) {
    if (!this.shouldRerenderLoadMore) return

    return this._renderEl('load-more', html)
  }

  /**
   * @param {string} section
   * @param {Document} html
   */
  _renderEl (section, html) {
    this.els[section].element.innerHTML = window.BAO.Utils.getElement(
      this.els[section].selector,
      { context: html },
    ).innerHTML
  }

  get shouldShowLoadPrevious () {
    const anElementFromTheFirstPageExists = !!window.BAO.Utils.getElement(
      `${this.els.item.selector}[data-page="1"]`,
    )
    if (anElementFromTheFirstPageExists) return false

    return this.currentPage > 1
  }

  get shouldShowLoadMore () {
    const anElementFromTheLastPageExists = window.BAO.Utils.getElement(
      `${this.els.item.selector}[data-page="${this.lastPage}"]`,
    )
    if (anElementFromTheLastPageExists) return false

    return Number(this.currentPage) < this.lastPage
  }

  get shouldRerenderLoadPrevious () {
    return this.currentPage <= this.currentLowestPage
  }

  get shouldRerenderLoadMore () {
    return this.currentPage >= this.currentHighestPage
  }

  get currentPage () {
    const params = this.searchParams.current
    const page = params.get('page')

    return Number(page) || 1
  }

  get currentLowestPage () {
    const gridItems = window.BAO.Utils.getElements(`${this.els.item.selector}`)

    return Number(gridItems[0].dataset.page) || 1
  }

  get currentHighestPage () {
    const gridItems = window.BAO.Utils.getElements(`${this.els.item.selector}`)

    return Number(gridItems[gridItems.length - 1].dataset.page) || 1
  }

  /**
   * @returns {number}
   */
  get lastPage () {
    return Number(this.dataset.lastPage)
  }

  /**
   * @param {URLSearchParams} searchParams
   *
   * @returns {void}
   */
  updateURLHash (searchParams) {
    history.pushState(
      { searchParams: searchParams.toString() },
      '',
      `${window.location.pathname}${
        searchParams && '?'.concat(searchParams.toString())
      }`,
    )
  }

  /**
   * @param {PointerEvent} e
   *
   * @return 'NEXT'|'PREVIOUS'|null
   */
  getPaginationDirection (e) {
    if (typeof e === 'undefined') return null

    const paginationElement = e.target.closest(
      `${this.els['load-previous'].selector}, ${this.els['load-more'].selector}`,
    )
    if (!paginationElement) return null

    return paginationElement === this.els['load-previous']?.element
      ? 'PREVIOUS'
      : 'NEXT'
  }

  get items () {
    return window.BAO.Utils.getElements(this.els.item.selector)
  }
}

if (!customElements.get('load-more')) {
  customElements.define('load-more', LoadMore)
}
